import { Component, Vue, PropSync, Watch, Emit } from 'vue-property-decorator';
import { AuthentificationService, FilterNewService } from '@/services';
import { EventStore } from '@/store/store.event';
import { DexieDataSetEvent } from '@/models/dexie/UnsyncedDexieDataSet';
import { LoggerService } from '@/utils';
import { AuthStore } from '@/store/store.auth';
import { UserWhitelistEnums } from '@/enums/UserWhitelistEnums';


@Component({
    components: {
    },
})
export default class UserProfileMenuComponent extends Vue {
    @PropSync('large', { type: Boolean }) public syncedLarge!: boolean;

    public isLoggedIn: boolean = false;
    public isWhitelisted: UserWhitelistEnums = UserWhitelistEnums.UNKNOWN;
    public userWhitelistEnums = UserWhitelistEnums;

    public disableUnsynced: boolean = true;
    public messages: number = 0;
    public on: any;


    // tslint:disable-next-line: no-empty
    public mounted() {
        this.isLoggedIn = this.getIsLoggedIn;
    }

    get getIsLoggedIn() {
        return AuthStore.isLoggedIn;
    }

    get getIsWhitelisted() {
        return AuthStore.isWhitelisted;
    }

    get getUnsyncedDataSets() {
        return EventStore.unsyncedEvents;
    }

    @Watch('getIsLoggedIn', { deep: false, immediate: false })
    public onGetIsLoggedInChanged(newValue: boolean) {
        this.isLoggedIn = newValue;
    }

    @Watch('getIsWhitelisted', { deep: false, immediate: true })
    public async onIsWhitelisted(newValue: UserWhitelistEnums) {
        this.isWhitelisted = newValue;
    }

    @Watch('getUnsyncedDataSets', { deep: true, immediate: true })
    public onGetUnsyncedDataSetsChanged(newValue: DexieDataSetEvent[]) {
        this.disableUnsynced = newValue && newValue.length <= 0;
        this.messages = newValue && newValue.length;
    }

    @Emit()
    public showUnsynced(): boolean {
        return true;
    }

    @Emit()
    public showUnitsMenu(): boolean {
        return true;
    }

    public onLoginClicked() {
        AuthentificationService.SignInRedirect();
    }

    public onUnsyncedClicked() {
        this.showUnsynced();
    }

    public async onLogoutClicked() {
        await FilterNewService.DeleteAllSyncedFilters();
        await FilterNewService.DeleteAllUnsyncedFilters();
        AuthentificationService.SingOutRedirect();
    }

    public onUnitFormatClicked() {
        this.showUnitsMenu();
    }

    public showItem(): boolean {
        let show = false;
        if (this.isLoggedIn && this.isWhitelisted === UserWhitelistEnums.WHITE) {
            show = true;
        }
        LoggerService.LogDebug(`${this.isLoggedIn} | ${this.isWhitelisted} | ${show}`);
        return show;
    }
}
